/**
 * 剧集首页网格：列数须与 `homeSeriesContent.scss` 里 `.home-series__grid` 的 media query 一致。
 * 列表接口 pageSize 取「列数 × 每页行数」，避免宽屏 7 列仍只拉 15 条导致末行空缺。
 */
const GRID_COL_BREAKPOINTS: { minWidth: number; columns: number }[] = [
  { minWidth: 1536, columns: 7 },
  { minWidth: 1280, columns: 6 },
  { minWidth: 1024, columns: 5 },
  { minWidth: 768, columns: 4 },
  { minWidth: 640, columns: 3 },
  { minWidth: 0, columns: 2 },
];

/** 与网格视觉一致：每页固定占满若干整行（当前为 3 行） */
export const HOME_SERIES_GRID_ROWS_PER_PAGE = 3;

export function getHomeSeriesGridColumnCount(viewportWidth: number): number {
  for (const row of GRID_COL_BREAKPOINTS) {
    if (viewportWidth >= row.minWidth) {
      return row.columns;
    }
  }
  return 2;
}

export function getHomeSeriesListPageSize(viewportWidth: number): number {
  const columns = getHomeSeriesGridColumnCount(viewportWidth);
  return columns * HOME_SERIES_GRID_ROWS_PER_PAGE;
}
